import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { animateScroll as scroll } from 'react-scroll';
import { ReactComponent as Sebrae } from '../../../../images/svgs/sebrae.svg';
import Button from '../../../ui/Button';
import { CaretUpIcon } from '../../../ui/icons';
import cn from '../../../ui/utils/cn';
import styles from './FooterBottomBar.module.css';

export default function FooterBottomBar({ menuSideBar }) {
  const { t } = useTranslation('footer');
  return (
    <div className={cn(styles.root, menuSideBar && styles.menuSideBar)}>
      <Sebrae className={styles.logo} />
      <p className={styles.desc}>{t('FOOTER_DESC')}</p>
      <Button
        variant='secondary'
        shape='sharp'
        className={styles.btn}
        aria-label={t('SCROLL_TO_TOP')}
        onClick={() => scroll.scrollToTop()}>
        <CaretUpIcon aria-hidden='true' />
        <span className={styles.btnLabel}>{t('SCROLL_TO_TOP')}</span>
      </Button>
    </div>
  );
}

FooterBottomBar.propTypes = {
  menuSideBar: PropTypes.bool
};
